var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_3759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 11L10 10M5.75 10.5C6.37378 10.5 6.99145 10.3771 7.56775 10.1384C8.14404 9.89972 8.66768 9.54984 9.10876 9.10876C9.54984 8.66768 9.89972 8.14404 10.1384 7.56775C10.3771 6.99145 10.5 6.37378 10.5 5.75C10.5 5.12622 10.3771 4.50855 10.1384 3.93225C9.89972 3.35596 9.54984 2.83232 9.10876 2.39124C8.66768 1.95016 8.14404 1.60028 7.56775 1.36157C6.99145 1.12286 6.37378 1 5.75 1C4.49022 1 3.28204 1.50045 2.39124 2.39124C1.50044 3.28204 1 4.49022 1 5.75C1 7.00978 1.50044 8.21796 2.39124 9.10876C3.28204 9.99956 4.49022 10.5 5.75 10.5V10.5Z",
    stroke: "#292D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_3759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9183fcc4bac6b42207cef19212c4ac1d.svg";
export { ForwardRef as ReactComponent };